import axios from 'axios';
//  var baseUrl = process.env.REACT_APP_API || 'https://localhost:5000/api';
//  var baseUrl = process.env.REACT_APP_API || 'http://digital-advisory-web-qa.herokuapp.com/api/';
var baseUrl = process.env.REACT_APP_API || "https://china-safety-cert-dev-dbdc44996284.herokuapp.com/api";
console.log('env var:',process.env.REACT_APP_API);
//  const baseUrl = process.env.REACT_APP_API || "https://china-safety-cert-uat-6d244a69ec81.herokuapp.com/";
//  console.log('env var:',baseUrl);
// withCredentials: true so the auth_token cookie is sent with every API call —
// required now that /api/request/* and /api/user/gettoken sit behind verifyAuth.
const instance = axios.create({ baseURL: baseUrl, withCredentials: true });

// Strip credentials on cross-origin requests (e.g. SharePoint download.aspx).
// SharePoint does not return Access-Control-Allow-Credentials: true, so leaving
// withCredentials on would cause the browser to block the response with a
// CORS error. Same-origin calls (relative URLs, or absolute URLs to our own
// API) keep withCredentials so the auth_token cookie is sent.
const apiOrigin = (() => {
    try { return new URL(baseUrl).origin; } catch (e) { return ''; }
})();
instance.interceptors.request.use((config) => {
    const url = config.url || '';
    if (/^https?:\/\//i.test(url)) {
        let requestOrigin = '';
        try { requestOrigin = new URL(url).origin; } catch (e) { /* ignore */ }
        if (requestOrigin && requestOrigin !== apiOrigin) {
            config.withCredentials = false;
        }
    }
    return config;
});
// const downloadInstance = axios.create({
//     baseURL: process.env.REACT_APP_SP_DOWNLOADURL
// });
export default instance;
    